import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend';
export const dispatch_onRecapFeedUpdated = new ThunderDispatcher('__onRecapFeedUpdated');
//# sourceMappingURL=dispatcher.js.map